// JsFromRoutes CacheKey e3a1d11d09c460d452385de813500ba2
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  create: /* #__PURE__ */ definePathHelper('post', '/vacancies'),
  new: /* #__PURE__ */ definePathHelper('get', '/vacancies/new'),
  update: /* #__PURE__ */ definePathHelper('patch', '/vacancies/:id'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '/vacancies/:id'),
}
